import AINav from './AINav';

export default AINav;
